/** The build the web app was served with (injected by Vite from build-info.json). */
export type WebBuild = { version: string; commit: string; dirty: boolean; builtAt: string };

declare const __BUILD_INFO__: WebBuild;

export const webBuild: WebBuild =
  typeof __BUILD_INFO__ === 'undefined' ? { version: 'dev', commit: 'unknown', dirty: true, builtAt: 'unknown' } : __BUILD_INFO__;
